export default __webpack_public_path__ + "static/media/Party_goodie.0e1ff5d8.svg";